import * as React from "react";
import AppNavigation from "../Navigation/AppNavigtation";

export default class RootContainer extends React.Component {
  render() {
    return <AppNavigation />;
  }
}



// WEBPACK FOOTER //
// ./src/Containers/RootContainer.tsx